<template>
    <div>
        <introduction-title en-title="JOIN US" ch-title="职业机会" style="margin-top: 20px"></introduction-title>
        <span class="wapTitle">
            &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;人才是公司最宝贵的财富！公司致力于在内部打造一个尊重知识，尊重人才的和谐工作氛围。在斯普瑞科技，您可以与许多优秀的人才合作，他们致力于创新，他们致力于为化工生产提供更先进的突破性技术。如果你喜欢一家务实，创新的公司，喜欢高效率的工作环境，喜欢多元化的发展，那么，我相信您会喜欢斯普瑞科技工作，加入我们，您将拥有众多增长知识，提高技能的机会，您可根据自身的特长和兴趣来选择技术发展路线或管理发展路线。
        </span>
        <div class="careerWap" style="margin-top: 40px">
            <div class="li" v-for="item in data1" :key="item.id">
                <div class="header" @click="item.judge=!item.judge" style="cursor: pointer">
                    <i class="iconfont icon-zhiwei" style="float: left"></i>
                    <span class="name" style="font-weight: bold;color: #0067AC;margin-left: 20px;">{{item.name}}</span>
                    <!--                    <span class="num" style="font-weight: bold;color: #0067AC;margin-left: 20px">3名</span>-->
                    <span style="float: right;margin-right: 10px;height:64px;">
                        <i class="iconfont icon-a-zhiweiweizhi" style="color:#9DA6AC;font-size: 18px;margin-right: 5px;float: left;"></i>
<!--                        <span style="color: #9DA6AC">{{item.position}}</span>-->
                        <span style="color: #9DA6AC">重庆</span>
                        <i class="iconfont icon-a-zhiweimoren" style="font-size: 30px;cursor: pointer" v-if="!item.judge" ></i>
                        <i class="iconfont icon-a-zhiweizhankai" style="font-size: 30px;cursor: pointer"  v-else></i>
                    </span>
                </div>
                <div class="center" v-if="item.judge">
                    <div v-html="item.htmls" style="text-align: left"></div>
                </div>
            </div>
            <div class="li"></div>
            <div class="li"></div>
        </div>
    </div>
</template>

<script>
    import IntroductionTitle from "@/components/wap/introductionTitle.vue";
    export default {
        name: "wapCareerOpportunities",
        components: {IntroductionTitle},
        data(){
            return{
                data1:[]
            }
        },
        mounted() {
            this.data1 =require('../../../assets/JSONData/product/occupation.json');
        }
    }
</script>

<style scoped>
    .wapTitle{
        width:355px;
        margin:10px auto;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #363A44;
        line-height: 24px;
        text-align: justify;
        display: block;
    }
    .careerWap{
        width:355px;
        margin:0 auto;
    }
    .careerWap .li{
        width: 355px;
        background: #F8FBFD;
        border-radius: 1px;
        margin-bottom: 20px;
    }
    .careerWap .li .header{
        height: 64px;
        line-height: 64px;
        text-align: left;
        width:355px;
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    }
    .careerWap .li .header i{
        font-size: 22px;
        margin-left: 10px;
    }
    .careerWap span{
        display: block;
        float: left;
    }
    .center{
        margin-left: 30px;
        padding-top: 20px;
        padding-bottom: 20px;
        border-top: 1px dashed #979797;
        line-height: 24px;
        margin-right: 30px;
    }
</style>
